<template>
  <hcm-card
    :resource="resource"
    :cardImage="resource.image"
    :cardInfo="sourceTimeAgo()"
    :cardTitle="resource.headline"
    :resourceUrl="resource.url"
    :externalResource="true"
    :cardText="resource.summary"
    :hasSource="true"
    :cardSourceUrl="resource.url"
    :cardSourceAuthor="resource.source"
    :hasShare="true"
    :shareTag="shareTag"
    :shareTitle="shareTitle"
    :shareUrl="shareUrl"
  ></hcm-card>
</template>

<script>
import HCMCard from "./HCMCard.vue";
export default {
  components: { "hcm-card": HCMCard },
  props: {
    resource: {
      type: Object,
      required: true
    }
  },
  computed: {
    shareTag() {
      return "News item";
    },
    shareTitle() {
      return this.resource["headline"];
    },
    shareUrl() {
      return `${window.location.origin}/detail/NewsItem/${this.resource["uuid"]}`;
    }
  },
  methods: {
    sourceTimeAgo: function() {
      // TODO: need to add timer for updates...

      const d = new Date(this.resource.postingDate);
      const now = new Date();
      const seconds = Math.round(
        Math.abs((now.getTime() - d.getTime()) / 1000)
      );
      // const timeToUpdate = (Number.isNaN(seconds)) ? 1000 : this.getSecondsUntilUpdate(seconds) * 1000;

      const minutes = Math.floor(Math.abs(seconds / 60));
      const hours = Math.floor(Math.abs(minutes / 60));
      const days = Math.floor(Math.abs(hours / 24));
      const months = Math.floor(Math.abs(days / 30.416));
      const years = Math.floor(Math.abs(days / 365));

      if (Number.isNaN(seconds)) {
        return "";
      } else if (seconds <= 45) {
        return "a few seconds ago";
      } else if (seconds <= 90 || minutes === 1) {
        return "1 minute ago";
      } else if (minutes <= 45) {
        return minutes + " minutes ago";
      } else if (minutes <= 90 || hours === 1) {
        return "1 hour ago";
      } else if (hours <= 22) {
        return hours + " hours ago";
      } else if (hours <= 36 || days === 1) {
        return "1 day ago";
      } else if (days <= 25) {
        return days + " days ago";
      } else if (days <= 45) {
        return "1 month ago";
      } else if (days <= 345 || months === 1) {
        return months + " months ago";
      } else if (days <= 545 || years === 1) {
        return "1 year ago";
      } else {
        // (days > 545)
        return years + " years ago";
      }

      // this.removeTimer();

      // const d = new Date(value);
      // const now = new Date();
      // const seconds = Math.round(Math.abs((now.getTime() - d.getTime()) / 1000));
      // const timeToUpdate = (Number.isNaN(seconds)) ? 1000 : this.getSecondsUntilUpdate(seconds) * 1000;

      // this.timer = this.ngZone.runOutsideAngular(() => {
      //     if (typeof window !== 'undefined') {
      //         return window.setTimeout(() => {
      //             this.ngZone.run(() => this.changeDetectorRef.markForCheck());
      //         }, timeToUpdate);
      //     }
      //     return null;
      // });
    }
  }
};
</script>
